module.exports = __webpack_public_path__ + "73e57937304d89f251e7e540a24b095a.gif";